import { IconExcelAttach, IconFileAttach, IconPdfAttach, IconPowerpointAttach, IconTextAttach, IconWordAttach, IconZipAttach } from "../icons/svg";
/**
 * Z-index for components that are to be rendered like an overlay, to be over
 * everything, such as modal-type of components, or dialogs.
 */
export const OVERLAY_Z_INDEX = 1000;
export const FILE_TYPES = {
    COMPRESS: {
        name: 'zip',
        icon: IconZipAttach
    },
    EXCEL: {
        name: 'x',
        icon: IconExcelAttach
    },
    IMAGE: {
        name: 'img',
        icon: IconFileAttach
    },
    VIDEO: {
        name: 'vid',
        icon: IconFileAttach
    },
    PDF: {
        name: 'pdf',
        icon: IconPdfAttach
    },
    WORD: {
        name: 'w',
        icon: IconWordAttach
    },
    POWERPOINT: {
        name: 'pp',
        icon: IconPowerpointAttach
    },
    TEXT: {
        name: 'text',
        icon: IconTextAttach
    },
    SOUND: {
        name: 'sound',
        icon: IconFileAttach
    },
    FILE: {
        name: 'file',
        icon: IconFileAttach
    }
};
